import { Typography, Box, Container, Button } from '@mui/material';
import Confetti from 'react-confetti';
import { imageAssetUrl } from '../../utils/publicAssets';

const logo = imageAssetUrl('logo-menu.png');

const ThankYouPage = () => {
  return (
    <Container maxWidth="sm">
      <Confetti recycle />
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        {/* Never wider than the column. The logo image is 1796px wide and was
            capped only at 400px, so on any phone narrower than 400px it hung off
            both edges of the screen and the page scrolled sideways. The 400px
            cap still applies wherever there is room for it. */}
        <img
          src={logo}
          alt="Logo"
          style={{ maxWidth: 'min(400px, 100%)', marginBottom: 20 }}
        />
        {/* "Congratulations!" is one word that cannot wrap. At the h4 size,
            inside 32px of padding, it is wider than a 320px phone leaves, so the
            card pushed past the screen. On phones the card's padding and the
            heading are smaller; from the sm breakpoint up both are as before. */}
        <Box
          textAlign="center"
          bgcolor="background.paper"
          p={{ xs: 2.5, sm: 4 }}
          borderRadius={2}
          boxShadow={3}
        >
          <Typography
            variant="h4"
            gutterBottom
            sx={{
              color: 'primary.main',
              fontSize: { xs: '1.75rem', sm: '2.125rem' }
            }}
          >
            🎉 Congratulations! 🎉
          </Typography>
          <Typography variant="h5" sx={{ mt: 2, fontWeight: 'medium' }}>
            You're all set and in the running for the giveaway!
          </Typography>
          <Typography variant="h6" sx={{ mt: 2 }}>
            Be sure to check your email for instructions on how to redeem your
            cards.
          </Typography>
          <Box mt={4}>
            <Typography variant="body1" sx={{ fontStyle: 'italic' }}>
              Good luck, and thank you for your purchase!
            </Typography>
          </Box>
          <Button variant="contained" color="primary" href="/" sx={{ mt: 2 }}>
            Back to Homepage
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default ThankYouPage;
